import { render } from "./Template.vue?vue&type=template&id=70fba5d0"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"

import "./Template.vue?vue&type=style&index=0&id=70fba5d0&lang=scss"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__